import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import cx from 'classnames';
import { Button, Modal } from '@storable/canaveral-components';
import useCurrentPage from '../../../hooks/useCurrentPage';
import { Price, Size, Amenities } from './columns';
import styles from './columns/Actions/Actions.scss';

const propTypes = {
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

const defaultProps = {
  children: undefined,
};

const SelectedUnitModal = (props) => {
  const { primaryColorClass, buttonStyleClass } = useCurrentPage();
  const { handleClose, children, ...rest } = props;
  const overrideProps = { ...props, isModal: true, isSelectedUnitModal: true };

  return (
    <Modal
      show
      onDismiss={handleClose}
      className={styles.mobileModal}
      backdrop="static"
      disableCloseButton
    >
      <Modal.Header className={styles.modalHeader}>
        <div className={cx(styles.title, primaryColorClass)}>
          What would you like to do with this unit selection
        </div>
        <Button
          context="dark"
          icon="times"
          size="sm"
          onClick={handleClose}
          className={styles.closeButton}
          label="close"
        />
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12} className={styles.text}>
            Selected Unit
          </Col>
        </Row>
        <Row className={styles.columns}>
          <Col
            xs={3}
          >
            <Size
              {...rest}
            />
          </Col>
          <Col xs={6} className={styles.features}>
            <Amenities
              {...rest}
            />
          </Col>
          <Col xs={3} className={styles.price}>
            <Price {...overrideProps} />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        {children}
        <Button
          context="neutral"
          className={`${styles.differentUnit} ${buttonStyleClass}`}
          block
          onClick={handleClose}
        >
          Select Different Unit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

SelectedUnitModal.propTypes = propTypes;
SelectedUnitModal.defaultProps = defaultProps;

export default SelectedUnitModal;
